import { create } from 'zustand';
import { GenerateOutlineResponse } from '../../../services/getAiResponse'; // Adjusted path

export interface Outline extends GenerateOutlineResponse {
  metadata: {
    characters: number;
    words: number;
    tone: string;
    language: string;
  };
}

interface Store {
  outlines: Outline[];
  addOutline: (outline: Outline) => void;
}

export const useStore = create<Store>((set: (fn: (state: Store) => Store) => void) => ({
  outlines: [],
  addOutline: (outline: Outline) =>
    set((state: Store) => ({
      ...state,
      outlines: [...state.outlines, outline],
    })),
}));